import { requestServerApi, serverApi } from '../api/api';
import { devConfig } from '../config/dev';
import { IS_DEMO } from '../config/env-config';
export type UserInfo = {
  nickName: string;
  userId: string;
  role: string;
};
interface IUserService {
  fetchLoginUserInfo(): Promise<UserInfo | null>;
}
class UserServiceApp implements IUserService {
  async fetchLoginUserInfo(): Promise<UserInfo | null> {
    const result = await requestServerApi<any>(() => serverApi.organizationsControllerGetLoginUserInfo()).catch(
      (error) => {
        console.error(error);
      }
    );
    if (result?.data?.code === 200) {
      const nickName = result?.data?.data?.nickName;
      const userId = result?.data?.data?.userId;
      const role = result?.data?.data?.role;
      return {
        nickName: nickName,
        userId: userId,
        role: role
      };
    } else {
      return null;
    }
  }
}

class UserServiceDemo implements IUserService {
  async fetchLoginUserInfo(): Promise<UserInfo | null> {
    console.log('Demo mode: fetchLoginUserInfo called');
    const { name, role, topic, signature } = devConfig;

    return {
      nickName: name,
      role: role === 1 ? 'teacher' : 'learner',
      userId: name
    };
  }
}
export const UserService: new () => IUserService = IS_DEMO ? UserServiceDemo : UserServiceApp;
